import { render } from "./ModalAttendance.vue?vue&type=template&id=3dacd9aa"
import script from "./ModalAttendance.vue?vue&type=script&lang=js"
export * from "./ModalAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__